import { Component } from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {SharedModule} from "../../../shared/shared.module";
import {AgencySidebarComponent} from "../sidebar/agency-sidebar.component";
import {AgencyHeaderComponent} from "../agency-header/agency-header.component";
import {AgencyDashCardComponent} from "../agency-dash-card/agency-dash-card.component";
import {NgForOf} from "@angular/common";
import { AuthService } from '../../../services/auth.service';
import { PermissionService } from '../../../services/permission.service';
import { AgencyPermission, USER_ACCOUNT_PERMISSIONS } from '../../../shared/utils/agency-rbac';

@Component({
  selector: 'app-agency-dash',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule,
    AgencySidebarComponent,
    AgencyHeaderComponent,
    AgencyDashCardComponent,
    NgForOf
  ],
  templateUrl: './agency-dash.component.html',
  styleUrl: './agency-dash.component.scss'
})
export class AgencyDashComponent {

  constructor(public auth: AuthService, private permissions: PermissionService) {}

  /**
   * Tiles shown to the connected role. A legacy admin keeps the full menu, a legacy collaborator
   * (recruteur) keeps exactly its previous restricted menu (établissements, professionnels,
   * affectation directe).
   */
  get menu(): any[] {
    return this.menuItems.filter((item: any) => this.permissions.has(item.permission));
  }

  menuItems:any = [
    {
      desc: 'Gestion des établissements',
      path: '/agency/establishment',
      btnText: 'ACCÉDER AUX ÉTABLISSEMENTS',
      icon: 'company'
    },
    {
      desc: 'Gestion des professionnels de santé',
      path: 'agency/candidates',
      btnText: 'ACCÉDER AUX PROFESSIONNELS',
      icon:'doctor'
    },
    // Lot C (client clinique) : carte « Gestion de vos agences » masquée du dashboard — code conservé
    // {
    //   desc: 'Gestion de vos agences',
    //   path: 'agency/agencies',
    //   btnText: 'ACCÉDER AUX AGENCES',
    //   icon: 'agency',
    //   permission: AgencyPermission.AGENCY_SETTINGS
    // },
    {
      desc: 'Gestion des collaborateurs',
      path: 'agency/users',
      btnText: 'GÉRER LES COLLABORATEURS',
      icon:'padlock-tools',
      permission: USER_ACCOUNT_PERMISSIONS
    },
    {
      desc: 'Comptes professionnels à valider',
      path: 'agency/pro-accounts',
      btnText: 'VALIDER LES COMPTES PROFESSIONNELS',
      icon:'doctor',
      permission: AgencyPermission.VALIDATE_PRO_ACCOUNT
    },
    {
      desc: 'Affectation directe',
      path: '/agency/direct-assign',
      btnText: 'ACCÉDER À L\'AFFECTATION DIRECTE',
      icon:'target',
      permission: AgencyPermission.MISSION_WRITE
    },
    {
      desc: "Relevés d'heures",
      path: '/agency/weekly-hours',
      btnText: 'ACCÉDER AUX RELEVÉS D\'HEURES',
      icon:'document',
      permission: AgencyPermission.FINANCE_VIEW
    },
    {
      desc: "Journal d'audit",
      path: '/agency/audit',
      btnText: 'CONSULTER LE JOURNAL',
      icon:'document',
      permission: AgencyPermission.AUDIT_VIEW
    },
  ]
}
